// import React from 'react';
// import './ukg_services_hero.css';
// import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

// const UKGServicesHero = () => {
//   return (
//     <section className="hero-container-us">
//       <div className="hero-content-us">
       
        
//         <h1 className="hero-title-us">
//           <span className='hero-title-us2'></span> <span className="highlight-text-us">Delivering Excellence as a UKG Certified Partner</span>
//         </h1>
        
//         <p className="hero-description-us">
//         We provide UKG-certified workforce solutions that streamline operations, ensure compliance, and enhance performance, delivering exceptional value through our strategic partnership with UKG.
//         </p>
//       </div>
      
//       {/* <div className="wave-bottom-us"></div> */}
//     </section>
//   );
// };

// export default UKGServicesHero;

import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import './ukg_services_hero.css';
import vynlogo from '../../img/des_sec/vyn_content.svg'; // Adjust the path as necessary

const UKGServicesHero = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // animation repeats on re-entry
    threshold: 0.1,
  });

  const fadeIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(20px)',
    config: { duration: 800 },
  });

  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(-20px)',
    config: { duration: 1000 },
  });

  const textAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(10px)',
    config: { duration: 1000 },
  });

  return (
    <section className="hero-container-us" ref={ref}>
      <animated.div className="hero-content-us" style={fadeIn}>
        <animated.h1 className="hero-title-us" style={titleAnimation}>
          <span className='hero-title-us2'></span> 
          <span className="highlight-text-us">Delivering Excellence as a UKG Certified Partner</span>
        </animated.h1>

        <animated.p className="hero-description-us" style={textAnimation}>
          We provide UKG-certified workforce solutions that streamline operations, ensure compliance, and enhance performance, delivering exceptional value through our strategic partnership with UKG.
        </animated.p>
      </animated.div>
      {/* <div className="wave-bottom-us"></div> */}
    </section>
  );
};

export default UKGServicesHero;
